// extracted by mini-css-extract-plugin
export default {"wrapper":"RO","header":"SO","headerwrap":"TO","title":"UO","icon":"VO","textwrap":"WO"};
    if(module.hot) {
      // 1713996748911
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  